import React, { useEffect, useState } from 'react';

import Search from '../../elements/Search';
import Paginator from '../../elements/paginator';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';
import { TableCell as Cell } from 'crm/elements/common/TableDetailsRow';
import TableHead from 'crm/elements/common/TableHead';
import { IS_CASINO_ENABLED } from 'crm/helpers/Constants';

function AffiliateOwnersList({ url, cardTitle, getLinks, loading, setLoading }) {
    const [affiliateOwners, setAffiliateOwners] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [filter, setFilter] = useState('');

    const getAffiliateOwners = (page = 1) => {
        const requestUrl = `${url}?page=${page}`;
        axios.get(requestUrl, { params: { filter } }).then((response) => {
            setAffiliateOwners(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
            setLoading(false);
        });
    };

    useEffect(() => {
        if (loading) {
            getAffiliateOwners();
        }
    }, [loading]);

    useEffect(() => {
        if (currentPage > lastPage) {
            // useful when deleting last item
            getAffiliateOwners(lastPage);
        }
    }, [currentPage, lastPage]);

    useEffect(() => {
        getAffiliateOwners();
    }, [filter]);

    function getAffiliateOwnersList() {
        return affiliateOwners.map((admin) => (
            <tr key={admin.id}>
                <Cell>{getLinks(admin.id)}</Cell>
                <Cell>{admin.id}</Cell>
                <Cell>{admin.name}</Cell>
                <Cell>{admin.email}</Cell>
                <Cell>{admin.country}</Cell>
                <Cell>{admin.state}</Cell>
                <Cell>{admin.aff_percent_revenue ?? 0}%</Cell>
                <Cell>{admin.ggr_aff_percent_revenue ?? 0}%</Cell>
                {IS_CASINO_ENABLED && <Cell>{admin.casino_aff_percent_revenue ?? 0}%</Cell>}
            </tr>
        ));
    }

    return (
        <Card title={cardTitle}>
            <div className="table-responsive">
                <Search filterTable={(value) => setFilter(value)} />
                <table className="table model-list">
                    <TableHead>
                        <div />
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Country</th>
                        <th>State</th>
                        <th>Affiliate revenue (default commission)</th>
                        <th>Affiliate revenue (GGR commission)</th>
                        {IS_CASINO_ENABLED && <th>Casino affiliate revenue</th>}
                    </TableHead>
                    <tbody>{getAffiliateOwnersList()}</tbody>
                </table>
                <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getAffiliateOwners} />
            </div>
        </Card>
    );
}

export default AffiliateOwnersList;
